import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import classes from './HomeChallengeLeaderboard.module.scss';
import { FiltersRow } from './components/FIltersRow/FIltersRows';
import { ChallengeLeaderboard, leaderboardStore } from '../../../challenges';

type HomeChallengeLeaderboardProps = {
  challengeId: number;
};

const HomeChallengeLeaderboard = observer(
  ({ challengeId }: HomeChallengeLeaderboardProps) => {
    const { challengeInfo, getLeaderboardList, getChallengeInfo, setDefaultValues } =
      leaderboardStore;

    const getData = async () => {
      await getChallengeInfo(challengeId);
      await getLeaderboardList();
    };

    useEffect(() => {
      getData();

      return () => {
        setDefaultValues();
      };
    }, [challengeId]);

    if (!challengeInfo) {
      return null;
    }

    return (
      <>
        <h2 className={classes.title}>Leaderboard</h2>
        <FiltersRow />
        <ChallengeLeaderboard variant="inBox" />
      </>
    );
  },
);

export { HomeChallengeLeaderboard };
